(() => {
  let loadPromise = null;

  const ensureSearch = () => {
    if (customElements.get('predictive-search-component')) return Promise.resolve();
    if (loadPromise) return loadPromise;
    const modal = document.querySelector('#search-modal');
    const url = modal?.dataset.predictiveSearchScript;
    if (!url) return Promise.resolve();

    loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = url;
      script.fetchPriority = 'low';
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.append(script);
    }).catch((error) => {
      loadPromise = null;
      console.warn('[wemond] Arama bileşeni yüklenemedi', error);
    });

    return loadPromise;
  };

  const isSearchTrigger = (event) => Boolean(event.target.closest?.('.search-action'));
  document.addEventListener('pointerover', (event) => {
    if (isSearchTrigger(event)) ensureSearch();
  }, { passive: true });
  document.addEventListener('focusin', (event) => {
    if (isSearchTrigger(event)) ensureSearch();
  });
  document.addEventListener('click', (event) => {
    if (isSearchTrigger(event)) ensureSearch();
  }, true);
})();
